import { useTranslation } from 'react-i18next';

export default function SiteUnavailableNotice() {
  const { t } = useTranslation();
  return (
    <main className="min-h-screen grid place-items-center p-8 text-center">
      <div>
        <h1 className="text-2xl font-semibold mb-2">{t('notice.siteUnavailableTitle')}</h1>
        <p className="text-gray-600">
          {t('notice.siteUnavailableBody')}
        </p>
      </div>
    </main>
  );
}
